// Vue 3 + Vue Router 4
import { createRouter, createWebHistory } from 'vue-router'
import TheContainer from '@/containers/TheContainer.vue'

const EtaxForm = () => import('@/views/Etax/EtaxForm.vue') 
const DownloadFile = () => import('@/views/Callback/DownloadFile.vue')
const TokenError = () => import('@/views/Callback/TokenError.vue')
const ReceiptEntry = () => import('@/views/ReceiptEntry.vue')
const DateExpired = () => import('@/views/Callback/DateExpired.vue')
const TaxInvoiceEntry = () => import('@/views/TaxInvoiceEntry.vue')


const routes = [
  {
    path: '/' ,
    component: TheContainer,
    children: [
      {
        path: '/s/:token',   // ✅ เพิ่มใหม่
        name: 'TaxInvoiceEntry',
        component: TaxInvoiceEntry,
      },
      {
        path: '/:token' ,
        name: 'ReceiptEntry',
        component: ReceiptEntry,
      },
      {
        path: '/downloadfile',
        name: 'DownloadFile',
        component: DownloadFile,
      },
      {
        path: '/tokenerror',
        name: 'TokenError',
        component: TokenError,
      },
      {
        path: '/dateexpired',
        name: 'DateExpired',
        component: DateExpired,
      },
     {
        path: '/invoice/error',
        name: 'Error',
        component: () => import('@/views/Callback/Error.vue')
      }
    ]
  },

]

const router = createRouter({
  history: createWebHistory(),      
  routes,
  scrollBehavior() { return { top: 0 } },
  linkActiveClass: 'active',
})

export default router
